import { XemploLoader } from '@xemplo/loader';

import { LogoutProps } from './auth-helper.types';
import { useLogout } from './hooks';

export function Logout(props: LogoutProps) {
  useLogout(props);
  return <XemploLoader />;
}
